module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K6VByr/tc-custom/9781460388358.jpg?1728851674278",
      "alt": "This image is the cover for the book Missing in the Glades, Marshland Justice"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Missing in the Glades, Marshland Justice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A private investigator pairs up with a beautiful stranger to search for a missing person in the Florida Everglades in this romantic suspense.")]), _c('br'), _c('br'), _vm._v("Looking for a fresh start, detective Jake Young headed south on a case that could help launch his PI business. He knew no amount of work would make him forget his tortured past, but maybe Faye Star could help. Caught up in Jake’s missing persons case, the distracting Faye was hiding a secret he was begging to find out. Expertly guiding him through the swamps, Jake’s job grew more complicated when someone started taking shots at the free-spirited beauty. As much as she protested she could take care of herself, Jake stepped in, refusing to admit how desperately he needed someone to save. Especially since he’d never be able to save himself. . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lena Diaz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lena's heart belongs to the rolling hills of her homestate of Kentucky. But you're more likely to see her near the ocean these days in northeast Florida where she resides with her hubby and two children. A former Romance Writers of America's Golden Heart® finalist, she's also a four-time winner of the Daphne du Maurier award and a Publisher's Weekly Bestseller. When not writing, she can be found sprucing up her flower beds or planning her next DIY project.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0